import { Controller } from "@hotwired/stimulus";

// Static page, nothing to wire up — kept for this project's own convention of every
// component carrying its own controller file.
export default class extends Controller {
  connect() {}
}
